// Key is country code
const FLAG_SPRITE_POSITION_MAP = {
  AD: -6336,
  AE: -6302,
  AG: -6266,
  AI: -6232,
  AL: -6197,
  AM: -6162,
  AN: -6127,
  AO: -6092,
  AR: -6057,
  AT: -6022,
  AU: -5987,
  AW: -5952,
  AZ: -5917,
  BA: -5882,
  BB: -5847,
  BE: -5811,
  BF: -5776,
  BG: -5742,
  BH: -5707,
  BI: -5671,
  BJ: -5637,
  BM: -5602,
  BN: -5567,
  BO: -5532,
  BR: -5497,
  BS: -5462,
  BT: -5427,
  BW: -5392,
  BY: -7002,
  BZ: -5357,
  C2: -5147,
  CA: -5322,
  CD: -5287,
  CG: -5251,
  CH: -947,
  CI: -7142,
  CK: -5217,
  CL: -5182,
  CM: -7177,
  CO: -5112,
  CR: -5077,
  CV: -5042,
  CY: -5007,
  CZ: -4972,
  DE: -4937,
  DJ: -4902,
  DK: -4867,
  DM: -4832,
  DO: -4797,
  DZ: -4762,
  EC: -4727,
  EE: -4692,
  EG: -72,
  ER: -4658,
  ES: -4621,
  ET: -4587,
  FI: -4552,
  FJ: -4517,
  FK: -6232,
  FM: -4447,
  FO: -4412,
  FR: -4377,
  GA: -4342,
  GB: -4307,
  GD: -4272,
  GE: -6652,
  GF: -4377,
  GI: -4202,
  GL: -4167,
  GM: -4132,
  GN: -3992,
  GP: -6582,
  GR: -4062,
  GT: -4027,
  GW: -3992,
  GY: -3957,
  HK: -3922,
  HN: -3887,
  HR: -3852,
  HU: -3817,
  ID: -3782,
  IE: -3747,
  IL: -3712,
  IN: -3677,
  IS: -3642,
  IT: -3607,
  JM: -3572,
  JO: -3537,
  JP: -3502,
  KE: -3467,
  KG: -3432,
  KH: -3397,
  KI: -3362,
  KM: -3327,
  KN: -3292,
  KR: -3257,
  KW: -3222,
  KY: -4482,
  KZ: -3152,
  LA: -3117,
  LC: -3082,
  LI: -3047,
  LK: -3012,
  LS: -2977,
  LT: -2942,
  LU: -2907,
  LV: -2872,
  MA: -2837,
  MC: -7037,
  MD: -6932,
  ME: -6862,
  MG: -2802,
  MH: -2767,
  MK: -6897,
  ML: -2732,
  MN: -6372,
  MQ: -2662,
  MR: -2627,
  MS: -2592,
  MT: -2557,
  MU: -2522,
  MV: -2487,
  MW: -2452,
  MX: -2417,
  MY: -2382,
  MZ: -2347,
  NA: -2312,
  NC: -7317,
  NE: -2242,
  NF: -2207,
  NG: -7072,
  NI: -2172,
  NL: -2137,
  NO: -2102,
  NP: -2067,
  NR: -2032,
  NU: -1997,
  NZ: -1962,
  OM: -1927,
  PA: -1892,
  PE: -1857,
  PF: -1822,
  PG: -1787,
  PH: -1752,
  PL: -1717,
  PM: -6827,
  PN: -6232,
  PT: -1682,
  PW: -1647,
  PY: -7247,
  QA: -5707,
  RE: -4377,
  RO: -1542,
  RS: -6721,
  RU: -1506,
  RW: -6442,
  SA: -1437,
  SB: -1402,
  SC: -1367,
  SE: -1332,
  SG: -1297,
  SH: -912,
  SI: -1262,
  SJ: -2102,
  SK: -1227,
  SL: -1192,
  SM: -1157,
  SN: -1122,
  SO: -1087,
  SR: -1052,
  ST: -1017,
  SV: -982,
  SZ: -6512,
  TC: -912,
  TD: -1542,
  TG: -842,
  TH: -807,
  TJ: -772,
  TM: -737,
  TN: -702,
  TO: -667,
  TR: -632,
  TT: -597,
  TV: -562,
  TW: -527,
  TZ: -492,
  UA: -457,
  UG: -422,
  US: -386,
  UY: -352,
  VA: -317,
  VC: -281,
  VE: -247,
  VG: -212,
  VN: -177,
  VU: -142,
  WF: -6792,
  WS: -107,
  YE: -72,
  YT: -6547,
  ZA: -37,
  ZM: -2,
  ZW: -7212,
};

export { FLAG_SPRITE_POSITION_MAP };
